<div id="add" [hidden]="!isInitialized">
  <form (ngSubmit)="submit()">
    <mat-form-field class="w-full">
      <input
        #textarea
        matInput
        style="resize: none"
        placeholder='Add entry using natural language, like "28 pizza #cash yesterday"...'
        class="w-full"
        [matAutocomplete]="auto"
        [matAutocompletePosition]="'above'"
        (keydown)="onKeydown($event)"
        [value]="''"
        (input)="updatePreview($event)"
      />

      <mat-autocomplete
        (closed)="isAutoCompleteOpen = false"
        (opened)="isAutoCompleteOpen = true"
        (optionSelected)="addTagFromAutocomplete($event)"
        #auto="matAutocomplete"
      >
        <mat-option
          *ngFor="let option of filteredTags; trakBy: trackByTagId"
          [value]="option"
        >
          <span class="tag" [ngClass]="getTagColor(option, tags)"
            >#{{ option.fullPath }}</span
          >
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <div class="p-4 pt-0 transition-opacity opacity-100 preview-container">
    <h2 class="font-bold text-lg mb-4">Entry preview</h2>
    <div
      class="p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center border-2 rounded-md"
    >
      <span
        class="p-1 text-green-500"
        [ngClass]="{ '!text-red-500': entry?.amount && entry?.amount! < 0 }"
        *ngIf="!!entry?.amount"
        >{{ entry?.amount | prefundCurrency }}</span
      >
      <span class="p-1" *ngIf="!entry?.amount" class="text-gray-400"
        >Amount</span
      >
      <span class="p-1" *ngIf="!!entry?.memo">{{ entry?.memo }}</span>
      <span class="p-1" *ngIf="!entry?.memo" class="text-gray-400">Memo</span>
      <span
        *ngIf="(entry?.tagFullPaths)!.length! > 0"
        class="flex flex-col items-start sm:items-center"
      >
        <span
          *ngFor="let tagFullPath of entry?.tagFullPaths"
          class="tag mb-1 mt-1"
          [ngClass]="getColorClass(tagFullPath)"
          >#{{ tagFullPath }}</span
        >
      </span>
      <span
        class="p-1 text-gray-400"
        *ngIf="!entry?.tagFullPaths || (entry?.tagFullPaths)!.length! === 0"
        >Tags</span
      >
      <span class="p-1" (click)="openDatePicker()">{{
        entry?.date | date
      }}</span>
    </div>
    <!-- <div class="flex justify-end mt-2 text-slate-400">
      <span>Press Enter to Submit</span>
    </div> -->
  </div>

  <div
    class="flex justify-between p-2 px-6 bg-gray-100 transition-opacity opacity-100"
  >
    <span>
      <span class="text-gray-400" (click)="close()"
        ><span class="underline cursor-pointer">Close</span> (Esc)</span
      >
    </span>
    <span class="text-gray-400"
      ><span class="underline cursor-pointer" (click)="save()">{{
        data.data.entry ? "Update & close" : "Save & close"
      }}</span>
      (Enter)
    </span>
  </div>
</div>
